<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay
      variant="white"
      :show="showLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <auto-partes-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <template #cell(precio)="data">
            {{ "$" + data.value }}
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class=""
              @click.prevent="edit(data.item)"
              v-b-tooltip.hover.top="'Editar'"
              variant="flat-success"
            >
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button
              size="sm"
              class=""
              @click="deleteAction(data)"
              v-b-tooltip.hover.top="'Eliminar'"
              variant="flat-danger"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group
                label-cols="4"
                label-cols-md="4"
                label-size="md"
                label="Entradas"
                label-for="input-md"
              >
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import autoPartesFilters from "./autoPartesFilters.vue";
import AutoPartsService from "@/services/AutoParts";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      showLoading: false,
      records: [],
      fields: [
        { key: "uniqueCode", label: "Codigo Único", sortable: true },
        { key: "originalCode", label: "Codigo Original", sortable: true },
        { key: "alterCode", label: "Codigo Alter.", sortable: false },
        { key: "description", label: "Descripción", sortable: false },
        {
          key: "AutopartBrand.name",
          label: "Marca AutoParte",
          sortable: false,
        },
        { key: "CarBrands.name", label: "Marca Vehiculo", sortable: false },
        { key: "autopartCategory.name", label: "Categoria", sortable: false },
        { key: "retailPrice", label: "Precio x Menor", sortable: false },
        {
          key: "wholesalePrice",
          label: "Precio x Mayor",
          sortable: false,
        },
        {
          key: "clientPrice",
          label: "Precio Cliente Final",
          sortable: false,
        },
        { key: "actions", label: "Acciones" },
      ],
      form: {
        id: null,
        autopartBrand: null,
        vehicleModel: null,
        originalCode: "",
        alterCode: "",
        description: "",
        extendedDescription: "",
        retailPrice: null,
        wholesalePrice: null,
        clientPrice: null,
      },
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: "id",
      order: "asc",
    };
  },
  components: {
    autoPartesFilters,
  },
  currentPage(newPage, oldPage) {
    if (newPage !== oldPage) {
      this.getData();
    }
  },

  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.records = [];
      this.totalElements = 0;

      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${
        this.order
      }&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;

      const autoParts = await AutoPartsService.getAutoParts(url, this.$store);
      const rows = autoParts.data?.rows || [];
      const total = autoParts.data?.responseFilter?.total_rows || 0;

      const maxPages = Math.ceil(total / this.showEntrie);

      this.records = rows;
      this.totalElements = total;
    },
    changeSizePage() {
      this.currentPage = 1;
      this.getData();
    },
    sortChanged(data) {
      this.sort = data.sortBy;
      if (data.sortDesc) {
        this.order = "desc";
      } else this.order = "asc";
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    edit(item) {
      this.form = {
        id: item.id,
        originalCode: item.originalCode,
        alterCode: item.alterCode,
        description: item.description,
        extendedDescription: item.extendedDescription,
        retailPrice: parseFloat(item.retailPrice),
        wholesalePrice: parseFloat(item.wholesalePrice),
        autopartCategoryId: item.autopartCategoryId,
        autopartBrandId: item.autopartBrandId,
        clientPrice: parseFloat(item.clientPrice),
        carBrandId: item.carBrandId,
        modelsIds: item.autopartVehicleModels.map((model) => model.carModelId),
      };
      this.$refs.filters.isAdd = true;
      this.$refs.filters.$children[0].getData(this.form);
      console.log("this.$refs.filters", this.$refs.filters);
    },
    async deleteAction(data) {
      this.$swal({
        title: "¿Desea eliminar esta autoparte?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, eliminalo",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.currentPage = 1;
          this.$swal({
            icon: "success",
            title: "Eliminado!",
            text: "El local ha sido eliminado.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.deleteData(data.item.id);
        }
      });
    },
    async deleteData(id) {
      console.log("id del postu", id);
      const resp = await AutoPartsService.deleteAutoPart(id, this.$store);
      console.log("resp delete", resp);
      if (resp) {
        this.getData();
      } else {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ocurrió un error al eliminar la autoparte.",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
      console.log("respDelete", resp);
    },
  },
};
</script>

<style></style>
